import { Call, East, PhoneAndroid, Place } from "@mui/icons-material";
import {
  alpha,
  Avatar,
  Box,
  Card,
  IconButton,
  Rating,
  styled,
} from "@mui/material";
import { FlexBetween, FlexBox } from "components/flex-box";
import { H3, Span } from "components/Typography";
import Link from "next/link";
import React from "react";
import { makeStyles } from "@mui/styles";

type ShopCard1Props = {
  branchName?: string;
  location?: string;
  telNo?: string;
  cellNo?: string;
  cellNo2?: string;
  coverImg?: string;
  gMapsPin?: string;
};

const ContentWrapper = styled(Box)<{ coverImg: string }>(
  ({ theme, coverImg }) => ({
    color: "white",
    backgroundSize: "cover",
    padding: "17px 30px 56px",
    backgroundPosition: "center",
    backgroundImage: `linear-gradient(to bottom,
    ${alpha(theme.palette.grey[900], 0.8)}, ${alpha(
      theme.palette.grey[900],
      0.8
    )}), 
    url(${coverImg || "/assets/images/banners/cycle.png"})`,
  })
);

const useStyles = makeStyles((theme) => ({
  cardHeight: {
    height: "200px",
  },
  liftOnHover: {
    transition: "0.5s",
    "&:hover": {
      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
      transform: "translateY(-5px)",
    },
  },
}));

const ShopCard1: React.FC<ShopCard1Props> = (props) => {
  const { branchName, location, telNo, cellNo, cellNo2, coverImg, gMapsPin } =
    props;
  const classes = useStyles();

  return (
    <a href={gMapsPin} target="_blank" rel="noopener noreferrer">
      <Card className={classes.liftOnHover}>
        <ContentWrapper coverImg={coverImg} className={classes.cardHeight}>
          <H3 fontWeight="600" mb={1}>
            {branchName}
          </H3>
          <FlexBox mb={1} gap={1}>
            <Place fontSize="small" sx={{ fontSize: 17, mt: "3px" }} />
            <Span color="white">{location}</Span>
          </FlexBox>

          <FlexBox alignItems="center" gap={1}>
            <Call fontSize="small" sx={{ fontSize: 17 }} />
            <span color="white">
              {telNo}
            </span>
          </FlexBox>

          <FlexBox alignItems="center" gap={1}>
            <PhoneAndroid fontSize="small" sx={{ fontSize: 17, mt: "3px" }} />
            <span color="white">
              {cellNo} / {cellNo2}
            </span>
          </FlexBox>
        </ContentWrapper>

        <FlexBetween pl={3} pr={2}>
          <Box ml="auto">
            <IconButton sx={{ my: 0.5 }}>
              <East
                sx={{
                  fontSize: 19,
                  transform: ({ direction }) =>
                    `rotate(${direction === "rtl" ? "180deg" : "0deg"})`,
                }}
              />
            </IconButton>
          </Box>
        </FlexBetween>
      </Card>
    </a>
  );
};

export default ShopCard1;
